import { render } from "./EventParticipationFull.vue?vue&type=template&id=a07babc4&ts=true"
import script from "./EventParticipationFull.vue?vue&type=script&lang=ts"
export * from "./EventParticipationFull.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__